<div
  #ref
  [issTabIndex]="-1"
  class="iss-side-nav"
  [class.iss-side-nav--expanded]="expanded"
  (tuiActiveZoneChange)="onActiveZone($event)"
>
  <ng-content select="iss-side-nav-header"/>
  <tui-scrollbar class="iss-side-nav-menu">
    <ng-content select="iss-portal-header"/>
    <ng-content/>
  </tui-scrollbar>
  <div class="tw-overflow-hidden">
    <ng-content select="[issSideNavFooter]"/>
  </div>
  <div class="iss-side-nav-container">
    <div class="iss-side-nav-arrow is-hidden-mobile" [class.expanded]="expanded">
      <iss-icon
        name="chevrons-left"
        data-e2e="side menu fold / expand button"
        (click)="toggleExpanded()"
      />
    </div>
  </div>
</div>
